export default __webpack_public_path__ + "static/media/Rolling-1s-200px (1).eb14e1e9.gif";